import React from "react";
import {Hidden} from "@unibuddy/patron";
import {useBooleanFeatureFlag} from "ub-feature-flagging-react";

import {SHOW_HAMBURGER_MENU} from "shared/constants";

import HeaderTabs from "../../HeaderBar/containers/HeaderTabs/HeaderTabs";
import MobileMenu from "../components/MobileMenu/MobileMenu";

const Navigation: React.FC<any> = (props) => {
    const isHamburgerMenuEnabled = useBooleanFeatureFlag(
        SHOW_HAMBURGER_MENU.key,
        SHOW_HAMBURGER_MENU.value,
    );

    if (isHamburgerMenuEnabled) {
        return (
            <>
                <Hidden above="mobile">
                    <MobileMenu {...props} showNba={false} />
                </Hidden>
                <Hidden below="tablet">
                    <HeaderTabs primaryApp={props.primaryApp} {...props} />
                </Hidden>
            </>
        );
    }

    return <HeaderTabs primaryApp={props.primaryApp} {...props} />;
};

export default Navigation;
